<div class="animated container-fluid container-filter">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 style="display:inline">Documentación para la Solicitud de Campaña</h4>
        <h4 style="display:inline">{{ solicitudCam?.Codigo }}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <img *ngIf="solicitudCam.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ solicitudCam.IdEstadoSolicitudCam | IconoEstadoSolicitudCam }}" ngbTooltip="{{ solicitudCam?.EstadoSolicitudCam }}" />
                <img *ngIf="!solicitudCam.IdEstadoSolicitudCam" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitudCam }}" ngbTooltip="{{ 'Nueva' }}" />
            </span>
        </h5>

        <div class="row pt-2">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn card-mb0">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseCabecera">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos de Campaña y Documentación configurada para la misma
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label" for="intCampaniaDescripcion">Campaña</label>
                                            <input formControlName="IdCampaniaDescripcion" name="IdCampaniaDescripcion" class="form-control" inputStyleClass="form-control" [ngClass]="displayFieldCss('IdCampaniaDescripcion')" type="text" value="" readonly>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label class="col-form-label required-field" for="inpAdjuntarDocumentacion">Adjuntar Documentación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="AdjuntarDocumentacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                        </div>

                                        <!-- Lista de tipos de documentos configurados para la campaña -->
                                        <ng-container *ngIf="!campaniaEspecifica?.AdjuntarDocumentacion">
                                            <div class="nota-info col-md-5">
                                                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> La configuración de la Campaña no permite adjuntar Documentación.</label>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="campaniaEspecifica?.AdjuntarDocumentacion">
                                            <div>
                                                <label class="col-form-label" for="">Tipos de Documentación admitidos (obligatorios o no) para la Solicitud de Campaña:</label>
                                            </div>
                                            <ng-container *ngIf="campaniaEspecifica?.Documentacion?.length === 0">
                                                <div class="col-md-5 nota-info error">
                                                    <label class="col-form-label"><i class="fa fa-exclamation" aria-hidden="true"></i> La Campaña no tiene configurado ningún Tipo de Documento.</label>
                                                </div>
                                            </ng-container>
                                            <div *ngFor="let documentoCam of campaniaEspecifica?.Documentacion; trackDocumentacionCam" class="form-group documentacion">
                                                <label class="col-form-label col-2" [ngClass]="{ 'required-field': documentoCam?.Obligatoria }" for="{{ prefixFormControlNameTipoDoc }}{{ documentoCam?.IdTipoDocumentacion }}">{{ documentoCam?.IdTipoDocumentacionDescripcion }}</label>
                                                <p-toggleButton class="form-control-togglebutton" formControlName="{{ prefixFormControlNameTipoDoc }}{{ documentoCam?.IdTipoDocumentacion }}" onLabel="Obligatoria" offLabel="NO Obligatoria" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                            </div>
                                            
                                        </ng-container>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>